<template>
  <div class="fixed inset-0 z-50 flex-col hidden text-center text-black bg-white print:flex print:text-left">
    <app-logo class="mb-8 -ml-2" />

    <div class="w-full h-full">
      <slot />
    </div>
  </div>
</template>

<script>
import isElectron from 'is-electron'
// import { useToast } from 'vue-toastification'

import AppLogo from '@/components/AppLogo.vue'

const { ipcRenderer } = isElectron() ? require('electron') : {}

export default {
  name: 'Print',
  components: {
    AppLogo,
  },
  emits: ['done'],
  data () {
    return {
      toast: undefined,

      isPrinting: false,
      isElectron: isElectron(),
    }
  },
  mounted () {
    // if (!this.toast) {
    //   this.toast = useToast()
    // }
  },
  methods: {
    done () {
      this.$emit('done')
    },
    print () {
      if (!this.isElectron) return

      ipcRenderer.send('print')

      ipcRenderer.once('print-result', (event, status) => {
        if (status === 'success') {
          // this.toast.success('พิมพ์เสร็จเรียบร้อยแล้ว')
        } else {
          // this.toast.error('การข้อผิดพลาดบางอย่างทำให้ไม่สามารถพิมพ์ได้')
        }
        this.done()
      })
    },
  },
}
</script>
